import React from 'react';
import PropTypes from 'prop-types';
import styled from 'styled-components';

import { Text } from 'core/ui/atoms';

const UserAvatar = ({ avatar, firstName }) => {
  return (
    <AvatarCont>
      {avatar ? (
        <Avatar src={avatar} />
      ) : (
        <EmptyAvatar>
          <Text style={{ fontSize: 24 }}>
            {firstName ? firstName[0] : 'П'}
          </Text>
        </EmptyAvatar>
      )}
    </AvatarCont>
  );
};

const AvatarCont = styled.div`
  width: 160px;
  height: 160px;
  filter: drop-shadow(0px 7px 70px rgba(255, 255, 255, 0.6));
  border-radius: 100px;
  background-image: -webkit-gradient(linear, left bottom, left top, color-stop(0.33, rgba(255, 255, 255, 0.8)),
    color-stop(0.67, rgba(255, 255, 255, 0.1)));
  padding: 3px;
  margin-bottom: 20px;
  display: flex;
  justify-content: center;
  align-items: center;
  overflow: hidden;
  ${p => p.theme.max('sm')`
    width: 140px;
    height: 140px;
    margin-bottom: 12px;
  `};
`;

const Avatar = styled.img`
  width: 160px;
  height: auto;
  border-radius: 100px;
  ${p => p.theme.max('sm')`
    width: 140px;
  `};
`;

const EmptyAvatar = styled.div`
  width: 160px;
  height: 160px;
  display: flex;
  justify-content: center;
  align-items: center;
  ${p => p.theme.max('sm')`
    width: 120px;
    height: 120px;
  `};
`;

UserAvatar.propTypes = {
  avatar: PropTypes.string,
  firstName: PropTypes.string,
};

export default UserAvatar;
